import React from "react";

// Tiny dependency-free SVG charts for the observation panels.
export const Sparkline = ({ values, color = "#38BDF8", w = 120, h = 26, testId }) => {
  if (!values?.length) return <svg width={w} height={h} data-testid={testId}><line x1={0} y1={h / 2} x2={w} y2={h / 2} stroke="rgba(255,255,255,0.08)" /></svg>;
  const min = Math.min(...values), max = Math.max(...values), span = Math.max(1e-9, max - min);
  const pts = values.map((v, i) => `${(i / Math.max(1, values.length - 1)) * w},${h - 2 - ((v - min) / span) * (h - 4)}`).join(" ");
  return <svg width={w} height={h} data-testid={testId}><polyline points={pts} fill="none" stroke={color} strokeWidth={1.4} /><circle cx={w} cy={h - 2 - ((values[values.length - 1] - min) / span) * (h - 4)} r={1.8} fill={color} /></svg>;
};

export const Bars = ({ values, color = "#38BDF8", w = 260, h = 48, testId, highlight }) => {
  if (!values?.length) return null;
  const max = Math.max(1e-9, ...values); const bw = w / values.length;
  return <svg width="100%" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" height={h} data-testid={testId}>{values.map((v, i) => <rect key={i} x={i * bw} y={h - (v / max) * h} width={Math.max(0.5, bw - 0.6)} height={(v / max) * h} fill={highlight?.(i) ? "#FB923C" : color} opacity={0.85} />)}</svg>;
};

export const Meter = ({ value, min = 0, max = 1, color = "#38BDF8", testId }) => {
  const k = Math.max(0, Math.min(1, ((value ?? min) - min) / Math.max(1e-9, max - min)));
  return <div className="h-1.5 bg-white/5 w-full" data-testid={testId}><div className="h-full transition-[width]" style={{ width: `${k * 100}%`, background: color }} /></div>;
};
